export const NAVIGATE_BREADCRUMB = 'navigate-breadcrumb';
export const BREADCRUMB_PIN_AS_STICKY_HEADER =
  'breadcrumb-pin-as-sticky-header';
